import React from 'react';
import { ChatButtonApp } from '@web/components/ChatButton/ChatButtonApp';
import { useSession } from '../api';
import { GladlyScript } from '../head';

export const GladlyContainer = ({ gladlySettings }) => {
  const { isAppSession } = useSession();
  if (isAppSession) return <></>;
  return (
    <>
      <GladlyScript />
      <ChatButtonApp gladlySettings={gladlySettings} />
    </>
  );
};
